export default "__VITE_ASSET__D39iVzAK__"